import useCart from "../../hooks/services/useCart.hook";

export default function CartNumber() {
  const { cartCount } = useCart();

  return (
    <p
      id="pos-cart-icon-qty"
      className="absolute text-xs -top-[3px] right-[2px] bg-her-dodgerblue w-5 h-5 flex items-center justify-center rounded-full p-2 text-white"
    >
      {cartCount}
    </p>
  );
}
